import './RoundButton.sass';

import React, { FC } from 'react';

import { RoundButtonProps } from '$uikit/RoundButton/RoundButton.interface';
import { classNames as cn } from '$utils';

export const RoundButton: FC<RoundButtonProps> = ({
  onClick,
  icon,
  size = 'medium',
  mode = 'default',
  disabled = false,
  className = '',
}) => {
  return (
    <div
      className={cn('RoundButton', size, mode, {
        [className]: !!className,
        disabled,
      })}
      onClick={onClick}
    >
      {icon}
    </div>
  );
};
